import React from 'react';
import { RefreshCw, Search } from 'lucide-react';

interface GrowthDateFilterProps {
  fromDate: string;
  toDate: string;
  onApply: (fromDate: string, toDate: string) => void;
  extra?: React.ReactNode;
}

const fieldClass =
  'rounded-xl border border-slate-800 bg-slate-950/60 px-3 py-2 text-xs font-semibold text-slate-100 outline-none transition placeholder:text-slate-600 focus:border-cyan-500/50 [color-scheme:dark]';

const GrowthDateFilter = ({ fromDate, toDate, onApply, extra }: GrowthDateFilterProps) => {
  const [localFrom, setLocalFrom] = React.useState(fromDate);
  const [localTo, setLocalTo] = React.useState(toDate);

  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-slate-800 bg-slate-900/60 p-4 lg:flex-row lg:items-center">
      <div className="flex items-center gap-2">
        <label className="text-[10px] font-black uppercase tracking-widest text-slate-500">From</label>
        <input type="date" value={localFrom} onChange={(e) => setLocalFrom(e.target.value)} className={fieldClass} />
      </div>
      <div className="flex items-center gap-2">
        <label className="text-[10px] font-black uppercase tracking-widest text-slate-500">To</label>
        <input type="date" value={localTo} onChange={(e) => setLocalTo(e.target.value)} className={fieldClass} />
      </div>
      {extra}
      <div className="flex gap-2 lg:ml-auto">
        <button
          onClick={() => onApply(localFrom, localTo)}
          className="inline-flex items-center justify-center gap-2 rounded-xl bg-cyan-500 px-4 py-2 text-xs font-black uppercase tracking-wider text-slate-950 transition hover:bg-cyan-400"
        >
          <Search size={14} />
          Apply
        </button>
        <button
          onClick={() => {
            setLocalFrom('');
            setLocalTo('');
            onApply('', '');
          }}
          title="Clear range"
          className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-800 bg-slate-950/60 px-4 py-2 text-xs font-black uppercase tracking-wider text-slate-400 transition hover:text-slate-200"
        >
          <RefreshCw size={14} />
        </button>
      </div>
    </div>
  );
};

export default GrowthDateFilter;